(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-blog-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Only run slider on mobile
  if (window.innerWidth >= 768) return;
  
  const slider = document.querySelector('.content-blog-v1');
  const slides = document.querySelectorAll('.blog-v1-slide');
  const dotsContainer = document.querySelector('.blog-v1-dots');
  
  if (!slider || slides.length === 0) return;
  
  let currentIndex = 0;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let isDragging = false;
  let animationID;
  
  // Create dots
  function createDots() {
    dotsContainer.innerHTML = '';
    
    if (slides.length <= 1) {
      dotsContainer.style.display = 'none';
      return;
    }
    
    for (let i = 0; i < slides.length; i++) {
      const dot = document.createElement('div');
      dot.classList.add('blog-v1-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
  }
  
  // Update dots
  function updateDots() {
    const dots = document.querySelectorAll('.blog-v1-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }
  
  // Go to specific slide
  function goToSlide(index) {
    currentIndex = index;
    setPositionByIndex();
  }
  
  // Set slider position
  function setPositionByIndex() {
    const slideWidth = slides[0].offsetWidth;
    currentTranslate = currentIndex * -slideWidth;
    prevTranslate = currentTranslate;
    setSliderPosition();
    updateDots();
  }
  
  // Set slider transform
  function setSliderPosition() {
    slider.style.transform = `translateX(${currentTranslate}px)`;
  }
  
  // Touch start
  function touchStart(event) {
    startX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    isDragging = true;
    animationID = requestAnimationFrame(animation);
    slider.style.transition = 'none';
  }
  
  // Touch move
  function touchMove(event) {
    if (isDragging) {
      const currentX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      currentTranslate = prevTranslate + currentX - startX;
    }
  }
  
  // Touch end
  function touchEnd() {
    isDragging = false;
    cancelAnimationFrame(animationID);
    
    const movedBy = currentTranslate - prevTranslate;
    const slideWidth = slides[0].offsetWidth;
    
    // Snap to nearest slide
    if (movedBy < -slideWidth / 4 && currentIndex < slides.length - 1) {
      currentIndex++;
    }
    
    if (movedBy > slideWidth / 4 && currentIndex > 0) {
      currentIndex--;
    }
    
    slider.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    setPositionByIndex();
  }
  
  // Animation loop
  function animation() {
    setSliderPosition();
    if (isDragging) requestAnimationFrame(animation);
  }
  
  // Add event listeners
  slider.addEventListener('touchstart', touchStart);
  slider.addEventListener('touchmove', touchMove);
  slider.addEventListener('touchend', touchEnd);
  slider.addEventListener('mousedown', touchStart);
  slider.addEventListener('mousemove', touchMove);
  slider.addEventListener('mouseup', touchEnd);
  slider.addEventListener('mouseleave', () => {
    if (isDragging) touchEnd();
  });
  
  // Prevent context menu on long press
  slider.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });
  
  // Initialize
  createDots();
  setPositionByIndex();
  
  // Handle orientation change
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 768) {
      slider.style.transform = 'none';
      slider.style.transition = 'none';
      return;
    }
    
    currentIndex = Math.min(currentIndex, slides.length - 1);
    setPositionByIndex();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-grid"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
    $('.collection-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 600, 
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3.5
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();
})();
